module.exports = __webpack_public_path__ + "static/media/HeadFITAudioToolBodyPostureFeedbackV1.3356a93a.mp3";